import jsPDF from "jspdf";

// Base64 payloads stored as text via Vite
// utils/ralewayFont.ts
import RalewayRegularRaw from "../src/fonts/Raleway-Regular.base64.txt?raw";
import RalewayBoldRaw from "../src/fonts/Raleway-Bold.base64.txt?raw";

function normalizeBase64(input: unknown): string {
  let s = String((input as any)?.default ?? input ?? "");

  // strip BOM / invisible chars / whitespace
  s = s.replace(/^\uFEFF/, "");
  s = s.replace(/[\u200B-\u200D\u2060]/g, "");
  s = s.replace(/\s+/g, "");

  // strip data-url prefixes if present
  s = s.replace(/^data:.*;base64,/, "");

  // url-safe → standard
  s = s.replace(/-/g, "+").replace(/_/g, "/");

  // remove non-base64
  s = s.replace(/[^A-Za-z0-9+/=]/g, "");

  // padding
  const pad = s.length % 4;
  if (pad === 2) s += "==";
  else if (pad === 3) s += "=";
  else if (pad === 1) return "";

  return s;
}

export function loadRaleway(doc: jsPDF): boolean {
  try {
    const regular = normalizeBase64(RalewayRegularRaw);
    const bold = normalizeBase64(RalewayBoldRaw);

    if (!regular || !bold) return false;

    const d: any = doc as any;

    // VFS registration — base64 ONLY (no atob)
    d.addFileToVFS("Raleway-Regular.ttf", regular);
    d.addFileToVFS("Raleway-Bold.ttf", bold);

    // Unified family registration
    d.addFont("Raleway-Regular.ttf", "Raleway", "normal");
    d.addFont("Raleway-Bold.ttf", "Raleway", "bold");

    // Force initial font so widths tables are built
    doc.setFont("Raleway", "normal");

    return true;
  } catch {
    try {
      doc.setFont("helvetica", "normal");
    } catch {}
    return false;
  }
}
